var Constants = require('../constants');
var Moment = require('moment');
var MomentRange = require('moment-range');
var moment = MomentRange.extendMoment(Moment);
var humanizeDuration = require('humanize-duration');
require('moment-timezone');
module.exports = {
    getGuessedTimezone: function () {
        var timezone = Constants.DEFAULT_TIME_ZONE;
        try {
            timezone = moment.tz.guess();
        } catch (e) {}
        return timezone;
    },
    // Returns the current client time in UTC seconds
    getNowTimestampSeconds: function () {
        return Math.round(moment.utc().valueOf() / 1000);
    },
    getNowTimestampMs: function () {
        return moment.utc().valueOf();
    },
    getFromNow: function (timestampSec) {
        return moment.unix(timestampSec).local().fromNow();
    },
    getFormattedTimestamp: function (timestampSec, options) {
        if (!timestampSec) {
            return '';
        }

        options = _.defaults(
            options || {},
            {
                displayTimezone: null,
                format: Constants.DEFAULT_DATE_TIME_DISPLAY_FORMAT
            }
        );

        if (options.displayTimezone) {
            var timezoneTime = moment.tz(timestampSec * 1000, options.displayTimezone);
            return timezoneTime.format(options.format);
        } else {
            return moment.unix(timestampSec).local().format(options.format);
        }
    },
    // Returns duration (in seconds by default) from compareToMomentUTC to now
    getTimeDiffFromNowUTC (compareToMomentUTC, unit) {
        var unit = unit || 'seconds';
        var nowMoment = moment.utc();
        return nowMoment.diff(compareToMomentUTC, unit);
    },
    // Turn millisecond duration into human-readable string
    getHumantizedDuration: function (durationMs) {
        try {
            return humanizeDuration(durationMs);
        } catch (e) {
            return '';
        }
    },
    isOverlappingDateRanges: function (range1FromTo, range2FromTo) {
        var range1 = moment.range(range1FromTo.from, range1FromTo.to);
        var range2 = moment.range(range2FromTo.from, range2FromTo.to);
        return range1.overlaps(range2);
    },
    convertTwelveHourTo24Hour: function (stringWithAmPm) {
      var amPm = stringWithAmPm.slice(stringWithAmPm.length - 2);
      var time = stringWithAmPm.replace(amPm, '');
      if (amPm == 'pm') {
        var hourArray = time.split(':');
        time = parseInt(hourArray[0]) + 12 + ':' + hourArray[1];
      }
      return time;
    },
    getTimeSlots: function (day, dayStartTime24Hour, dayEndTime24Hour, dayStartTimeAdjustment, dayEndTimeAdjustment, steps) {
      var dayStartTime24HourArray = dayStartTime24Hour.split(':');
      var dayEndTime24HourArray = dayEndTime24Hour.split(':');
      var day_start = moment(day, 'yyyy-mm-dd').startOf('day').hours(parseInt(dayStartTime24HourArray[0]) + (dayStartTimeAdjustment)).minutes(dayStartTime24HourArray[1]);
      var day_end = moment(day, 'yyyy-mm-dd').startOf('day').hours(parseInt(dayEndTime24HourArray[0]) + (dayEndTimeAdjustment)).minutes(dayEndTime24HourArray[1]);
      var day = moment.range(day_start, day_end);
      var time_slots = Array.from(day.by('minutes', {step: steps}));

      return time_slots;
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/utils/dates.js
 **/